import script from "./ExamForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamForm.vue?vue&type=script&setup=true&lang=js"

import "./ExamForm.vue?vue&type=style&index=0&id=71dae7df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71dae7df"]])

export default __exports__